/** Máximo de chips na barra: categorias inline + 1 chip "Todos"/dropdown. */
export const FILTER_BAR_MAX_INLINE = 2;

/** Linha do FilterBar overlay na Main. */
export const FILTER_BAR_OVERLAY_TOP = 55;
